<template>
  <!-- 章节 -->
  <div class="uni-menu-drawer">
    <div class="course-list">
      <el-collapse v-model.number="sectionUuid" class="uni-collapse" accordion>
        <div class="collapse-line"></div>
        <!-- 章 -->
        <el-collapse-item
          v-for="(item, index) in collapseDatas"
          :key="item.id"
          :name="item.id"
          @click="sectionUuid = item.id"
        >
          <template slot="title">
            <i
              v-if="item.id != lessonsUuid"
              class="uni-ico iconfont iconjiahao mar10 f20"
              style="color: #cdcdcd"
            ></i>
            <i
              v-else
              class="uni-ico iconfont iconjianhao mar10 f20"
              style="color: #cdcdcd"
            ></i>
            <span class="tit">{{ item.title }}</span>
          </template>

          <div
            class="item"
            v-for="(item2, index2) in item.node"
            :class="item2.id == lessonsUuid ? 'active' : ''"
            :key="item2.id"
            @click="changeLesson(item2.id, index, index2)"
          >
            <i class="iconfont iconbofang mar10"></i>
            <span>{{ item2.title }}</span>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
export default {
  name: "Catalog",
  props: {
    datas: {
      type: Array,
      default: () => {
        return [];
      },
    },
    lessonsUuidPr: {
      type: Number,
    },
  },
  data() {
    return {
      lessonsUuid: 0,
      sectionUuid: 0,
      drawerActiveTab: "first",
      collapseDatas: [],
      topIndex: 0,
      topIndex2: 0,
    };
  },
  mounted() {
    this.collapseDatas = this.datas;
    this.lessonsUuid = this.lessonsUuidPr || this.$route.query.lession_id;
  },
  watch: {
    datas(val) {
      this.collapseDatas = val;
      this.getActiveSection(val);
    },
    lessonsUuidPr(val) {
      this.lessonsUuid = val;
      this.getActiveSection(this.collapseDatas);
    },
  },
  methods: {
    // 当前展开的章
    getActiveSection(val) {
      if (val && val.length > 0) {
        val.forEach((item) => {
          item.node.forEach((valTo) => {
            if (valTo.id == this.lessonsUuid) {
              this.sectionUuid = valTo.section_id;
            }
          });
        });
      }
    },
    /**
     * 课程切换
     */
    changeLesson(lessonsUuid) {
      this.$emit("change", lessonsUuid);
    },
  },
};
</script>

<style lang="scss" scoped>
$tabContainerH: calc(100vh - 60px - 70px - 30px);
.uni-menu-drawer {
  color: $textGrayLight;
  height: $tabContainerH;
  //height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 -15px;

  .course-list {
    // flex: 1 1 auto;
    height: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    .item {
      padding: 5px 20px;
      font-size: 16px;
      color: #666;
      // @extend %ellipse;
      cursor: pointer;

      &:hover {
        color: #f60;
      }

      &.active {
        color: #fb5300;
        background: #f5f7fa;
      }
    }
  }

  .uni-ico {
    z-index: 100;
  }
  .uni-collapse {
    position: relative;
  }
  .collapse-line {
    position: absolute;
    top: 10px;
    bottom: 20px;
    left: 30px;
    width: 10px;
    border-left: 1px solid #f0f0f0;
    z-index: 10;
  }

  /deep/ .el-collapse-item__header {
    font-size: 18px;
    border-bottom: none;
    padding: 0 20px;
    position: relative;

    .el-collapse-item__arrow {
      display: none;
    }
  }

  /deep/ .el-collapse-item__wrap {
    border-bottom: 0;
  }
  /deep/ .el-collapse-item__content {
    padding-bottom: 10px;
    padding-top: 10px;
  }
  /deep/ .uni-collapse .el-collapse-item__header {
    align-items: flex-start;
    height: auto;
    line-height: 30px;
    // .tit {
    //   @extend %ellipse;
    //   flex: 1;
    // }
  }
  /deep/ .el-collapse-item__wrap {
    margin-left: 30px;
  }
}
</style>
